export default {
  newDesign: true,
  title: "Jawab 5 pertanyaan dan dapatkan pelajaran matematika gratis! | Kodland",
  downtimeUrl: "http://kodland.org/id",
  parameters: {
    landing_id: "IdMathN",
    segment: 4,
  },
  ageRules: {
    min: 8,
    max: 12,
  },
  startPage: {
    title:
      "Jawab 6 pertanyaan singkat dan dapatkan kelas matematika GRATIS!",
    subtitle: "✏️ Untuk anak berusia 8-12 tahun<br>💬 Mendiskusikan hobi dan pengalaman anak<br>🌐 Hanya membutuhkan komputer dan koneksi internet",
    button: " Ayo Mulai! 🚀 ",
    image: {
      url: "/welcome/math_freetc_indonesia_new_v2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/math_freetc_indonesia_new_v2_mob.png",
      style: {
        width: "100%",
      },
    },
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Terima kasih atas kepercayaan Anda pada platform pendidikan kami!",
    subtitle:
      "Sayangnya, tablet atau ponsel tidak sesuai untuk mengikuti pelajaran kami. Kami akan sangat senang melihat Anda di kelas berikutnya!",
  },
  quizRotateBySteps: {
    1: {
      title: "Pilih usia anak Anda..",
      type: "age",
      subtitle:
        "Ratusan ribu orang tua telah mempercayakan kami untuk meningkatkan prestasi anak mereka pada matematika.",
      button: "",
    },
    2: {
      question: "Apa pendapat anak Anda tentang matematika?",
      answers: [
        "😍 Sangat suka!",
        "🙂 Butuh sedikit dorongan",
        "😕 Kesulitan dan kerap menghindar",
        "🤔 Kurang suka, ingin diubah",
      ],
    },
    3: {
      question:
        "Menurut Anda, apakah semua pengetahuan akademis penting dikuasai oleh anak?",
      answers: [
        "📏 Sangat penting!",
        "🖌️ Penting, tapi kreativitas juga penting",
        "😃 Anak bisa menikmati belajar, bukan hanya nilai",
        "🤔 nak siap menghadapi masa depan",
      ],
    },
    4: {
      question:
        "Apa yang disukai anak Anda saat belajar?",
      answers: [
        "🕹️ Metode belajar sambil bermain",
        "📋 Penjelasan langkah-demi-langkah",
        "👥 Belajar di kelompok kecil",
        "👨‍🏫 Tutor yang menginspirasi",
        "🙌 Semua di atas"
      ],
    },
    5: {
      question:
        "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
      answers: [
        "💻 Ya, kami memiliki komputer/laptop di rumah",
        {
          answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
          stopAnswer: true,
        },
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/kid_ind2.png",
      subtitle: "Tutor kami membuat matematika menyenangkan dan mudah dipahami! Pilih waktu untuk kelas GRATIS.",
      button: "Pilih jadwal kelas 🕒",
    },
    7: {
      title: "Daftar untuk kelas uji coba gratis",
      type: "one-page-contacts",
      subtitle: "Mari saling mengenal, cari tahu apa saja yang akan kita pelajari, dan seperti apa proses belajarnya nanti.",
      button: "Lanjutkan 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Tinjau detail berikut untuk menyelesaikan pendaftaran ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Harap diperhatikan bahwa Anda akan membutuhkan komputer atau laptop yang berfungsi untuk pelajaran, dan Anda harus menemani anak Anda selama kelas berlangsung. Mohon diingat bahwa pelajaran ini bersifat individual dan personal.",
      button: "Selanjutnya bagaimana?",
    },
    10: {
      title: "Sebelum kelas uji coba, periksa email dan WhatsApp Anda 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Kami akan mengirimkan pengingat 24 jam sebelum kelas dimulai dan meminta Anda untuk mengonfirmasikan kehadiran Anda 2 jam sebelum kelas dimulai. Sangat penting untuk tetap berkomunikasi agar kelas tidak dibatalkan.",
      button: "Selanjutnya bagaimana?",
    },
    11: {
      title: "Kelas akan diadakan di platform kami 💻",
      typeInfo: "classroom",
      subtitle:
        "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Klik saja tautannya, dan Anda akan langsung diarahkan ke kelas. Tidak perlu aplikasi tambahan, tidak perlu mengunduh apa pun.",
      button: "Mengerti ✅",
    },
  },
};
